import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import Footer from '../layouts/Footer'
import Header from '../layouts/Header'
import './Checkout.css'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import { TInputEvent } from '../../global-type'
import { CheckoutCart } from './components'
import { checkoutAPI } from '../../redux/actions/checkout-actions'
import { OrderPrepare } from '../../api/types'
import { useNavigate } from 'react-router-dom'
import Loading from '../layouts/Loading'

type Country = {
  ccn3: string
  region: string
  subregion: string
  cioc: string
  name: {
    common: string
  }
}
const Checkout = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { user } = useAppSelector((state: RootState) => state.user)
  const { cart } = useAppSelector((state: RootState) => state.carts)
  const { loading } = useAppSelector((state: RootState) => state.checkout)

  const [countries, setCountries] = useState<Country[]>([])
  const [expand, setExpand] = useState({
    cash: false,
    bank: false
  })

  const total = () => {
    const totalPrice = cart.reduce((cur, item) => {
      cur += (item?.product?.price || 0) * (item?.quantity || 1)
      return cur
    }, 12.99)

    return totalPrice
  }

  const [prepareOrder, setPrepareOrder] = useState<OrderPrepare>({
    username: user?.username || '',
    email: user?.email || '',
    phone: user?.phone || '',
    company: user?.company || '',
    country: '',
    address: user?.address || '',
    payment_option: 'cash',
    total: total(),
    items: cart.map(item => ({
      _id: item._id,
      product: item.product._id,
      quantity: item.quantity
    }))
  })

  const { username, email, phone, company, country, address } = prepareOrder
  const handleSetInfor = (e: TInputEvent) => {
    setPrepareOrder(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const url = 'https://restcountries.com/v3.1/region/asia'
  useEffect(() => {
    const fetchCountries = async () => {
      await fetch(url)
        .then(res => res.json())
        .then(data => setCountries(data))
    }

    fetchCountries()
  }, [])

  const handlesubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!phone) return
    const regEx = '/^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/im'
    if (phone.match(regEx)) {
      toast.error('phone number not valid!!!')
      return
    } else if (phone.length > 12) {
      toast.error('phone number must contain maximum 10 numbers')
      return
    } else if (phone.length < 9) {
      toast.error('phone number must contain at least 10 numbers')
      return
    }
    toast.success('Payment processing')
    const result = await dispatch(checkoutAPI(prepareOrder))
    if (result.payload?.success) {
      toast.success(result.payload?.message)
    }
    navigate('/user')
  }

  return (
    <div className="main">
      {loading ? <Loading /> : null}
      <Header />
      <ToastContainer />
      <div className="checkout">
        <form className="ck__left" onSubmit={handlesubmit}>
          <div className="ck-form-wrap">
            <h1>payment details</h1>
            <p>complete your purchase by providing your peyment details</p>

            <div className="input__wrap">
              <div className="fm__input">
                <span className="title-input">Your name</span>
                <input
                  type="text"
                  name="username"
                  required
                  placeholder="Your full name"
                  value={username || ''}
                  onChange={handleSetInfor}
                />
              </div>
              <div className="fm__input">
                <span className="title-input">Your email</span>
                <input
                  type="email"
                  name="email"
                  required
                  disabled
                  placeholder="Your email"
                  value={email || ''}
                  onChange={handleSetInfor}
                />
              </div>
            </div>
            <div className="input__wrap">
              <div className="fm__input">
                <span className="title-input">Phone</span>
                <input
                  type="number"
                  name="phone"
                  required
                  placeholder="Your phone number"
                  value={phone || ''}
                  onChange={handleSetInfor}
                />
              </div>
              <div className="fm__input">
                <span className="title-input">Company(optional)</span>
                <input
                  type="text"
                  name="company"
                  placeholder="Your phone number"
                  value={company || ''}
                  onChange={handleSetInfor}
                />
              </div>
            </div>
            <div className="fm__input select">
              <span className="title-input">Select Your Country</span>
              <select
                name="country"
                value={country}
                onChange={handleSetInfor}
                required
              >
                <option value="none">--Select your country--</option>
                {countries.map(country => {
                  return (
                    <option
                      key={country.ccn3}
                      value={`${country.name.common} - ${country.region} - ${country.subregion}`}
                    >
                      {`${country.cioc} - ${country.name.common} - ${country.region} - ${country.subregion}`}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className="fm__input textarea">
              <span className="title-input">Your address</span>
              <textarea
                name="address"
                required
                value={address || ''}
                onChange={handleSetInfor}
              ></textarea>
            </div>
            <div className="ck-option">
              <div className={expand.cash ? 'option expand' : 'option'}>
                <label
                  className="op-check"
                  onClick={() => setExpand({ cash: true, bank: false })}
                >
                  <input
                    type="radio"
                    name="payment_option"
                    required
                    defaultChecked
                    value="cash"
                    onChange={handleSetInfor}
                  />
                  <div className="radio"></div>
                  <span>By Cash (default)</span>
                </label>
                <div className="bx-content">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Veritatis vel perspiciatis voluptates corrupti atque? Quas
                  perspiciatis repellat, id vero facilis mollitia, officiis
                  autem neque maxime veniam quod sequi, aperiam explicabo.
                </div>
              </div>
              <div className={expand.bank ? 'option expand' : 'option'}>
                <label
                  className="op-check"
                  onClick={() => setExpand({ cash: false, bank: true })}
                >
                  <input
                    type="radio"
                    name="payment_option"
                    required
                    value="bank"
                    onChange={handleSetInfor}
                  />
                  <div className="radio"></div>
                  <span>Pay By Bank Card</span>
                </label>
                <div className="bx-content">
                  <h1 style={{ color: '#e74c3c' }}>Comming soon</h1>
                  (Not available - default :payment on delivery for any order)
                </div>
              </div>
              <div className="check-submit">
                <input
                  className="submit-handle"
                  type="submit"
                  name="payment"
                  value="Checkout"
                />
              </div>
            </div>
          </div>
        </form>
        <CheckoutCart total={total()} />
      </div>
      <Footer />
    </div>
  )
}

export default Checkout
